import React, { useMemo } from 'react';
import Gallery from 'react-galleria';
import { postImageSetting, S3_LARGE_THUMB, S3_URL } from 'constants';
import { setModalConfig } from 'store/common';
import { getFileName } from 'utils';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

const PostPhotoGallery: React.FC<any> = ({ mediaItems, useS3Path = false }) => {
	const { translate } = useTranslate();
	const photos = useMemo(() => {
		const copyMedia = [...mediaItems].slice(0, 4);
		const numMediaItems: number = copyMedia.length;
		const settings = postImageSetting[numMediaItems] || [];
		const limitedSettings = settings.slice(0, 4);

		return copyMedia?.map((item: any, index: number) => {
			const { file } = item;
			const { width, height } = limitedSettings[index] || { width: 0, height: 0 };
			return {
				src: `${useS3Path ? S3_URL : S3_LARGE_THUMB}${file}` || '',
				width,
				height,
				index,
				videoThumbnail: useS3Path ? S3_URL : S3_LARGE_THUMB + getFileName(file),
			};
		});
	}, [mediaItems]);

	const mediaRenderer = (
		mediaType: any,
		src: any,
		width: any,
		height: any,
		index: number,
		videoThumbnail: string = '',
	) => {
		if (mediaType === 'video') {
			return (
				<>
					{photos?.length === 1 ? (
						<span className="single-video-icon">
							<img
								onClick={() => onAssetsClick(index)}
								src={videoThumbnail}
								width={width}
								height={height}
								alt="media"
								className="react-photo-gallery-video"
								loading="lazy"
							/>
							<i className="ri-play-large-fill"></i>
						</span>
					) : (
						<span className="react-photo-gallery-video-icon">
							<img
								onClick={() => onAssetsClick(index)}
								src={videoThumbnail}
								width={width}
								height={height}
								alt="media"
								className="react-photo-gallery-video"
								loading="lazy"
							/>
							<i className="ri-play-large-fill"></i>
							{index === 3 && mediaItems?.length - photos?.length > 0 && (
								<div
									className="img-overlay"
									onClick={() => onAssetsClick(index)}
									style={{ minWidth: `${width}px`, minHeight: `${height}px` }}
								>
									+{mediaItems?.length - photos?.length} {translate('Common.more')}
								</div>
							)}
						</span>
					)}
				</>
			);
		}

		return (
			<span className="react-photo-gallery-img">
				<img
					onClick={() => onAssetsClick(index)}
					src={src}
					width={width}
					height={height}
					alt="media"
					loading="lazy"
				/>
				{index === 3 && mediaItems?.length - photos?.length > 0 && (
					<div
						className="img-overlay"
						onClick={() => onAssetsClick(index)}
						style={{ minWidth: `${width}px`, minHeight: `${height}px` }}
					>
						+{mediaItems?.length - photos?.length} {translate('Common.more')}
					</div>
				)}
			</span>
		);
	};

	const onAssetsClick = (index: number) => {
		setModalConfig({
			visible: true,
			data: mediaItems,
			id: index,
			type: 'carouselModal',
			props: {
				fullscreen: true,
				centered: true,
				dialogClassName: 'dialog-assets-carousel',
			},
		});
	};

	const getMediaType = (url: any) => {
		const extension = url?.split('.').pop().toLowerCase();
		const videoExtensions = ['mp4', 'avi', 'mov', 'wmv', 'flv', 'mkv'];

		if (videoExtensions.includes(extension)) {
			return 'video';
		}
		return 'image';
	};

	const renderImage = ({ photo }: any) => {
		const { src, width, height, index, videoThumbnail } = photo;
		const mediaType = getMediaType(src);
		return mediaRenderer(mediaType, src, width, height, index, videoThumbnail);
	};

	let galleryClass = '';
	if (photos.length === 1) {
		galleryClass = 'single-image';
	} else if (photos.length === 2) {
		galleryClass = 'double-image';
	} else if (photos.length === 3) {
		galleryClass = 'triple-image';
	}
	return (
		<div style={{ marginBottom: '10px' }} className={`post-photo-gallery ${galleryClass}`}>
			<Gallery photos={photos} direction={'column'} renderImage={renderImage} />
		</div>
	);
};

export default PostPhotoGallery;
